import Right2 from '@assets/icons/right2.svg'
import { Icon } from './Icon'

export const Right2Icon = Icon(Right2)
